const AnnotationExportTypes = {
    GEOJSON: 'geojson',
    KML: 'kml',
};

export default AnnotationExportTypes;
